/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import {
  DialogWrapper,
  PopupHeadingText,
  DeleteWithdrawText,
  CloseIconStyle,
  ModifyPopupTextWrapper,
} from '../../../Vendor/Components/CreateBid.Style';
import Button, { ButtonType } from '../../../../Shared/Components/Common/Buttons/Button';
import { Icons } from '../../../../Shared/Constants/Icons';

interface ConfirmationDialogProps {
  open: boolean;
  handleClose: () => void;
  handleOnCloseJob: () => void;
  loading?: boolean;
  heading: string;
  text: React.ReactNode;
  label?: string;
  hideSecondaryLabel?: boolean;
  showCheckBox?: boolean;
  isChecked?: boolean;
  setIsChecked?: (checked: boolean) => void;
  checkBoxText?: React.ReactNode;
  width?: string | number;
}

const ModifyQuotePopup: React.FC<ConfirmationDialogProps> = ({
  open,
  handleClose,
  handleOnCloseJob,
  loading,
  heading,
  text,
  label,
  hideSecondaryLabel,
  showCheckBox,
  isChecked,
  setIsChecked,
  checkBoxText,
  width,
}) => {
  const { t } = useTranslation(['assignJob', 'jobManagement']);

  const toggleCheckbox = () => {
    setIsChecked?.(!isChecked);
  };
  return (
    <DialogWrapper open={open} onClose={handleClose}>
      <CloseIconStyle onClick={handleClose}>
        <img src={Icons.InfoWindowCloseIcon} alt={t('altTexts:closeIcon')} />
      </CloseIconStyle>
      <PopupHeadingText>{heading}</PopupHeadingText>
      <ModifyPopupTextWrapper>
        <DeleteWithdrawText style={{ whiteSpace: 'pre-line', width: width ?? 'auto', flexWrap: 'wrap' }}>
          {text}
        </DeleteWithdrawText>
      </ModifyPopupTextWrapper>
      {showCheckBox && (
        <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '1rem' }}>
          <Box onClick={toggleCheckbox}>
            {isChecked ? (
              <img
                src={Icons.CheckedIcon}
                alt={t('altTexts:checked')}
                style={{ cursor: 'pointer', height: '1.5rem', width: '1.5rem' }}
              />
            ) : (
              <img
                src={Icons.Unchecked}
                alt={t('altTexts:unchecked')}
                style={{ cursor: 'pointer', height: '1.5rem', width: '1.5rem' }}
              />
            )}
          </Box>
          <Typography sx={{ marginLeft: '0.625rem' }}>{checkBoxText}</Typography>
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '1.5rem',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
        }}>
        {!hideSecondaryLabel ? (
          <Button type={ButtonType.Secondary} label={t('assignJob:no')} onClick={handleClose} />
        ) : null}

        <Button
          type={ButtonType.Primary}
          label={label ? label : t('assignJob:yes')}
          onClick={handleOnCloseJob}
          disabled={loading}
          isLoading={loading}
        />
      </Box>
    </DialogWrapper>
  );
};

export default ModifyQuotePopup;
